import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

var dropdown = null;
if(window.innerWidth > 767) {
    dropdown = "header";
}

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    // historyEnabled: true,
    inputCssSelector: ".header-search-bar input#txt_search",
    // contentCssSelector: "#isp_search_result_page_container",
    contentCssSelector: ".skeleton-loader-wrapper",
    //dropdownCssSelector: dropdown,
    formCssSelector: ".header-search-bar form#WebSearch",
    hitDecorators: [
        thumbnailDecorator({ size: "9" })
    ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/pages/search-results',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    categoryCssSelector: '#isp_search_result_page_container, .plp-products-wrapper',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
   // document.addEventListener('DOMContentLoaded', function() {
        const input = document.querySelector('#WebSearch #txt_search');
    
        input.addEventListener('keyup', handleInput);
        input.addEventListener('input', handleInput); // 'update' is not a standard event, 'input' is the closest
        input.addEventListener('change', handleInput);
    
        function handleInput() {
            setTimeout(() => {
                const searchValue = document.querySelector('#WebSearch #txt_search').value;
                const firstWrapper = document.querySelector('#WebSearch > .nosto-autocomplete-wrapper > div:nth-child(2)');
                const HistoryWrapper = document.querySelector('#WebSearch > .nosto-autocomplete-wrapper > .nosto-autocomplete-wrapper > div:nth-child(2)');
    
                if (searchValue.length > 1) {
                    if (firstWrapper && firstWrapper.children.length > 0) {
                        firstWrapper.style.display = 'block';
                        firstWrapper.classList.add("ns-d-block");
                        HistoryWrapper.style.display = 'none';
                    } else {
                        HistoryWrapper.style.display = 'block';
                    }
                } else {
                    if (HistoryWrapper) HistoryWrapper.style.display = 'block';
                    if (firstWrapper) {
                        firstWrapper.style.display = 'none';
                        firstWrapper.classList.remove("ns-d-block");
                    }
                }
            }, 500);
        }
    //});
    
})

// $(document).ready(function () {
//     const $input = $('#WebSearch #txt_search');
  
  
//     $input.on('keyup update change', function () {
//         // console.log('Terry length', $('#WebSearch #txt_search').val())
//         setTimeout(()=>{
//             if($('#WebSearch #txt_search').val().length > 1 ) {
//                     if($('#WebSearch > .nosto-autocomplete-wrapper > div:nth-child(2)').children().length > 0) {
//                         console.log("if 2");
//                         // $('#WebSearch > .nosto-autocomplete-wrapper > div:nth-child(2)').css('display', 'block')
//                         // $('#WebSearch > .nosto-autocomplete-wrapper > .nosto-autocomplete-wrapper > div:nth-child(2)').css('display', 'none')
//                     } else {
//                         console.log("else 2");
//                         $('#WebSearch > .nosto-autocomplete-wrapper > .nosto-autocomplete-wrapper > div:nth-child(2)').css('display', 'block')
//                     }
                
//             } else {
//                 console.log("else 1")
//                 $('#WebSearch > .nosto-autocomplete-wrapper > .nosto-autocomplete-wrapper > div:nth-child(2)').css('display', 'block')
//                 $('#WebSearch > .nosto-autocomplete-wrapper > div:nth-child(2)').css('display', 'none')
//             }
//         }, 500)
//     });
//   });


